import * as React from 'react';
import BaseInput, { BaseInputSharedProps } from '../BaseInput';

type Props = BaseInputSharedProps & {
  multiline?: never;
  centered?: boolean;
  maxWidth?: number | string;
};

const Input: React.FC<Props> = ({ ...props }) => {
  return <BaseInput {...props} multiline={false} />;
};

export default Input;
